export default "__VITE_ASSET__DTM6NHd5__"